module.exports = __webpack_public_path__ + "5b3344eee1e7558993d0287e7ec73a4d.pdf";